import type { RumEvent } from '@datadog/browser-rum'

import { sanitizeUrl } from '@/utils/redaction/sanitize-url'

import { redactErrorText } from './redact-error-text'

/** trackResources records every fetch url, so a presigned S3 url would sit in
 *  Datadog as a usable write credential until it expires. Failed requests
 *  carry the same url on the error event, and its message and stack may quote
 *  it. Every event also carries the page url, whose query can hold a client's
 *  account number. */
export function redactRumEvent(event: RumEvent): void {
  if (event.view !== undefined) {
    event.view.url = sanitizeUrl(event.view.url)
    if (event.view.referrer !== undefined) {
      event.view.referrer = sanitizeUrl(event.view.referrer)
    }
  }

  if (event.type === 'resource') {
    event.resource.url = sanitizeUrl(event.resource.url)
    return
  }

  if (event.type === 'error') {
    redactErrorText(event.error)
    if (event.error.resource !== undefined) {
      event.error.resource.url = sanitizeUrl(event.error.resource.url)
    }
  }
}
